import { TFilter, TSearchItem, TSearchProps, TSearchPropsFields, TSearchPropsItemData, TSearchPropsItem } from '../types/search.types';

export class SearchApiModel {
  private readonly fields?: TSearchPropsFields;
  private readonly itemData?: TSearchPropsItemData;

  constructor(props: TSearchProps) {
    this.fields = props?.fields || null;
    this.itemData = props?.fields?.itemData;
  }

  get counter(): number {
    return this.fields?.apiData?.totalSearchResults || 0;
  }

  get results(): TSearchItem[] {
    return (
      this.fields?.apiData?.items?.map(({ title, description, link, highlight }: TSearchPropsItem) => ({
        title,
        description,
        link,
        highlight,
      })) || []
    );
  }

  get filters(): TFilter[] {
    return this.fields?.apiData?.filters || [];
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }

  get contextItemUrl(): string {
    return this.itemData?.contextItemUrl || '';
  }
}
